<template lang="pug">
	.creative--new-approval(v-if="creative")
		DxButton(v-if="!hasApproval", :text="$tCaption('Approval')", icon="fas fa-users", @click="showNewApproval")
		DxButton(v-if="hasApproval", :text="$tCaption('Approval')", icon="fas fa-users", @click="showApprovalsList")
		Popup(v-if="newApprovingPopupVisible", :popupVisible="newApprovingPopupVisible" :width="480", :autosize="true", :title="$tCaption('New approval')", :closeOnOutsideClick="false", @hiding="newApprovingPopupVisible = false")
			.flex-col.space-large.creative--new-approval
				.flex-col.space-medium
					.flex-col.space
						.flex-col.flex-1
							.font-small.upper.grey {{$tCaption('Name')}}
							DxTextBox(:value.sync="newApproval.Name", stylingMode="filled")
						.flex-col.flex-1
							.font-small.upper.grey {{$tCaption('Description')}}
							DxTextArea(:value.sync="newApproval.Description", :height="80", stylingMode="filled")
					.flex-col.space
						.font-big.upper.grey {{$tCaption('Approvers')}}
						.flex-row.space
							.flex-col.field.flex-1
								.font-small.upper.grey {{$tCaption('E-mail')}}
								DxTextBox(:value.sync="newApprover.email", valueChangeEvent="keyup", @value-changed="parseEmailValue")
							.flex-col.field.flex-1
								.font-small.upper.grey {{$tCaption('Name')}}
								DxTextBox(:value.sync="newApprover.name", valueChangeEvent="keyup")
						.flex-col.field.flex-1
							.font-small.upper.grey {{$tCaption('Invitation message')}}
							DxTextBox(:value.sync="newApprover.invitationMessage")
						DxButton(:text="$tCaption('Add approver')", :disabled="!newApprover.email", type="success", @click="addNewApprover")
				.flex-col.space
					.new-approver(v-for="approver in approvers")
						.flex-row.space.justify.align-center
							.flex-col
								.font-big {{approver.name}}
								.font-tiny.grey(v-if="approver.email !== approver.name") {{approver.email}}
							DxButton(icon="remove", @click="removeApprover(approver)")
				Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newApprovingPopupVisible = false")
				DxButton(:text="$tCaption('Submit for approval', '@actions')", type="success", @click="sendForApprove", :disabled="!approvers.length || !!isLoading")
		Popup(v-if="approversManagerVisible", :popupVisible="approversManagerVisible" :width="580", :height="520", :title="$tCaption('Manage approvers')", :closeOnOutsideClick="false", @hiding="approversManagerVisible = false")
			.flex-col.space-large.creative--new-approval
				Loader(v-if="!creativeApprovers.length && isLoading", text="")
				template(v-else)
					.flex-col.space-large
						.flex-col.space
							.flex-row.space
								.flex-col.field.flex-1
									.font-small.upper.grey {{$tCaption('E-mail')}}
									DxTextBox(:value.sync="newApprover.email", valueChangeEvent="keyup", @value-changed="parseEmailValue")
								.flex-col.field.flex-1
									.font-small.upper.grey {{$tCaption('Name')}}
									DxTextBox(:value.sync="newApprover.name", valueChangeEvent="keyup")
							.flex-col.field.flex-1
								.font-small.upper.grey {{$tCaption('Invitation message')}}
								DxTextBox(:value.sync="newApprover.invitationMessage")
							DxButton(icon="plus", @click="addCreativeApprover", :disabled="!!isLoading || !newApprover.email", :hint="$tCaption('Add approver')", :text="$tCaption('Add approver', '@actions')", type="success")
						.flex-col.space
							.approver(v-for="approver in creativeApprovers")
								.flex-row.space.justify.align-center
									.flex-col
										.font-big {{approver.Name}}
										.font-tiny.grey(v-if="approver.Email !== approver.Name") {{approver.Email}}
									.flex-row.space.align-center
										.font-small.upper(:class="[getStatus(approver).id]") {{getStatus(approver).name}}
										DxButton.small(icon="fas fa-rotate-right", stylingMode="text", @click="executeApproverAction(approver, 'reapprove')", :hint="$tCaption('Send e-mail for re-approve')")
										DxButton.small(icon="fas fa-times", stylingMode="text", @click="executeApproverAction(approver, 'remove')", :hint="$tCaption('Remove')")
						Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions') + '..'")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="approversManagerVisible = false")
		Popup(v-if="approvalListPopupVisible", :popupVisible.sync="approvalListPopupVisible" :width="640", :autosize="true", :closeOnOutsideClick="false", @hiding="approvalListPopupVisible = false")
			.flex-col.space.creative--new-approval
				ListView.full-width(initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadApprovals", :columns="columns", 
					:showColumnHeaders="false", :pageSize="2", ref="approvalsList", :bottomPagerVisible="false")
					template(slot="left-actions")
						.font-big.upper.grey {{$tCaption('Approvals')}}
					template(v-slot:name-template="{ data }")
						.flex-col.space-medium
							.flex-col.space
								.flex-row.justify.space
									.flex-col
										.font-mini.upper.grey {{$tCaption('Name')}}
										span {{data.Name}}
									.flex-row.space-large
										.flex-col(v-if="data.CreatedBy")
											.font-mini.upper.grey {{$tCaption('Author')}}
											.created {{data.CreatedBy.Contact ? data.CreatedBy.Contact.Title : data.CreatedBy.Name}}
										.flex-col
											.font-mini.upper.grey {{$tCaption('Status')}}
											span(:class="[getStatus(data).id]") {{getStatus(data).name}}
								.flex-col(v-if="data.Description")
									.font-mini.upper.grey {{$tCaption('Description')}}
									.description {{data.Description}}								
								.flex-col
									.font-mini.upper.grey {{$tCaption('Created')}}
									.created {{$moment(data.Created).format('LLL')}}
							.flex-row.space
								.approve-button.flex-row.space.align-center(@click="() => { open(data.Oid); approvalListPopupVisible = false; }")
									fas(icon="arrow-right")
									span {{$tCaption('Open approval page')}}
								template(v-if="data.CreatedBy.Oid === $auth.userId() && [0,3].includes(data.Status)")
									.approve-button.flex-row.space.align-center(@click="manageApprovers(data.Oid)", :class="{ disabled: !!isLoading }")
										fas(icon="users")
										span {{$tCaption('Manage approvers')}}
									.approve-button.flex-row.space.align-center(@click="uploadNewMixClick(data.Oid)", :class="{ disabled: !!isLoading }")
										fas(icon="upload")
										span {{$tCaption('Upload new audio mix')}}
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="approvalListPopupVisible = false")
			template(slot="actions-left")
				DxButton(:text="$tCaption('New approval', '@actions')", @click="showNewApproval", type="default")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import Loader from 'app-core/Loader.vue';
	import ListView from 'app-core/ListView.vue';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative--new-approval',
		components: {
			Popup, DxButton, DxTextBox, Loader, DxTextArea, ListView
		},
		props: ['creative', 'tracker', 'base64'],
		data() {
			const statuses = [
				{
					id: 'initial',
					name: this.$tCaption('Initial')
				},
				{
					id: 'accepted',
					name: this.$tCaption('Accepted')
				},
				{
					id: 'declined',
					name: this.$tCaption('Declined')
				},
				{
					id: 'progress',
					name: this.$tCaption('In progress')
				},
			];
			return {
				newApprovingPopupVisible: false,
				approversManagerVisible: false,
				approvers: [],
				newApprover: {
					email: null,
					name: null,
					invitationMessage: null
				},
				newApproval: {
					Name: null,
					Description: null
				},
				isLoading: false,
				creativeApprovers: [],
				statuses,
				approvalListPopupVisible: false,
				columns: [
					{ dataField: 'Name', caption: this.$tCaption('Name'), cellTemplate: 'name-template' },
				],
				lastApproval: null,
				managingApprovalId: null
			};
		},
		computed: {
			hasApproval() {
				return !!this.creative?.Approval;
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.newApproval = this;
		},
		methods: {
			showApprovalsList() {
				this.approvalListPopupVisible = false;
				this.$nextTick(() => this.approvalListPopupVisible = true);
			},
			loadApprovals(pageIndex, limit, opts) {
				return this.$Data.getExternalApi('CreativeApproval/List', `creativeOid=${this.creative.Oid}&page=${pageIndex + 1}&sorting=[{ selector: 'Created', desc: true }, { selector: 'Name', desc: false }]`, limit)
					.then(r => {
						this.lastApproval = r?.Results[0];
						return r;
					});
			},
			parseEmailValue() {
				let text = `${this.newApprover.email}`;
				if (text.indexOf('<') > -1) {
					let splitted = text.split('<');
					this.newApprover.email = splitted[1].replace(/[\>\<]/g,'').trim();
					this.newApprover.name = splitted[0].replace(/[\>\<]/g,'').trim();
				}
			},
			executeApproverAction(approver, action) {
				switch(action) {
					case 'remove':
						this.$confirmMessage({
							title: this.$tCaption('Confirm action', '@actions'),
							text: this.$tCaption('Are you sure you want to delete the current approver?'),
							handler: () => {
								this.isLoading++;
								this.$Data.postExternalApi('CreativeApproval/DeleteApprovers', [approver.Oid]).then(() => {
									this.$notifySuccess(this.$tCaption('Approver has been removed'));
									this.creativeApprovers.splice(this.creativeApprovers.findIndex(f => f.Oid === approver.Oid), 1);
								}).finally(() => this.isLoading--);
							}
						});
						break;
					case 'reapprove':
						this.$confirmMessage({
							title: this.$tCaption('Confirm action', '@actions'),
							text: this.$tCaption('Are you sure you want to notify the current approver for re-approve?'),
							handler: () => {
								this.isLoading++;
								this.$Data.postExternalApi('CreativeApproval/NotifyForApproval', {
									NotificationTemplateType: 1,
									ApprovalId: this.managingApprovalId || this.creative?.Approval?.Oid,
									NotifyAll: false,
									NotifyApprovers: [
										approver?.Oid
									]
								}).then(() => {
									this.$notifySuccess(this.$tCaption('Notification has been sent to approver'));
								}).finally(() => this.isLoading--);
							}
						});
						break;
				}
			},
			getStatus(approver) {
				return this.statuses[approver.Status] || this.statuses[0];
			},
			addCreativeApprover() {
				this.isLoading++;
				const { email, name, invitationMessage } = this.newApprover;
				this.newApprover = {
					name: null,
					email: null,
					invitationMessage: null
				};
				return this.$Data.postExternalApi('CreativeApproval/AddApprovers', [{
					Name: name || email,
					Email: email,
					CreativeApprovalId: this.managingApprovalId || this.creative.Approval?.Oid,
					InvitationMessage: invitationMessage
				}])
					.then(r => {
						if (r?.Data?.length)
							this.creativeApprovers.push(...r.Data);
					})
					.finally(() => this.isLoading--);
			},
			loadApprovers(approvalId) {
				this.isLoading++;
				this.creativeApprovers = [];
				return this.$Data.getExternalApi('CreativeApproval/GetApprovers', `creativeApprovalId=${approvalId}`).then(r => {
					this.creativeApprovers = r?.Results || [];
				}).finally(() => this.isLoading--);
			},
			async manageApprovers(approvalId) {
				await this.loadApprovers(approvalId);
				this.approversManagerVisible = false;
				this.managingApprovalId = approvalId;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.approversManagerVisible = true;
				})
			},
			async uploadNewMixClick(approvalId) {
				this.managingApprovalId = approvalId;
				await this.uploadAudioMix(approvalId);
				this.$notifySuccess(this.$tCaption('Audio uploaded'));
			},
			open(approvalId) {
				let routeData = this.$router.resolve({ path: `/approval/${approvalId}` });
				window.open(routeData.href, '_blank');
			},
			showNewApproval() {
				this.newApprovingPopupVisible = false;
				this.newApproval = {
					Name: null,
					Description: null
				};
				this.approvers = [];
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.newApprovingPopupVisible = true;
				})
			},
			addNewApprover() {
				this.approvers.push(this.newApprover);

				setImmediate(() => {
					this.newApprover = {
						email: null,
						name: null
					}
				});
			},
			removeApprover(approver) {
				this.approvers.splice(this.approvers.findIndex(f => f === approver), 1);
			},
			async uploadAudioMix(approvalId) {
				if (!approvalId) return;
				let base64 = '';
				if (this.tracker) {
					const r = await this.tracker?.generateFinalAudio();
					const blob = r.wav;
					base64 = await this.$Data.blob2Base64(blob);
				} else {
					base64 = this.base64;
				}
				if (!base64) return;
				this.isLoading++;
				return this.$azure.uploadCreativeApprovalAudio(approvalId, base64).finally(() => this.isLoading--);
			},
			async sendForApprove() {
				this.isLoading++;
				try {
					this.creative.Approval = (await this.$Data.postExternalApi('CreativeApproval/CreateUpdateApproval', {
						CreativeId: this.creative?.Oid,
						...(this.newApproval)
					}))?.Data;
					
					await this.uploadAudioMix(this.creative.Approval?.Oid);
					await this.addApprovers(this.creative.Approval?.Oid);

					this.newApprovingPopupVisible = false;
					this.$notifySuccess(this.$tCaption('Approval has bees successfully created'));

					if (this.$refs.approvalsList) {
						this.$refs.approvalsList.reload();
					}
				} finally {
					this.isLoading--;
				}
			},
			addApprovers(approvalId) {
				this.isLoading++;
				return this.$Data.postExternalApi('CreativeApproval/AddApprovers', this.approvers.map(f => ({
					Name: f.name || f.email,
					Email: f.email,
					CreativeApprovalId: approvalId,
					InvitationMessage: f.invitationMessage
				}))).finally(() => this.isLoading--);
			},
			notifyApprovers() {
				if (this.creative?.Approval?.Oid)
					return this.$Data.postExternalApi('CreativeApproval/NotifyForApproval', {
						ApprovalId: this.creative.Approval?.Oid
					});
			}
		}
	};
</script>
<style lang='scss'>
	.creative--new-approval {
		.new-approver {
			padding: 6px 10px;
			background: rgba(0,0,0,0.05);
			border-radius: 4px;
		}
		
		.approve-button {
			padding: 10px;
			background: rgba(0,0,0,0.03);
			border-radius: 4px;
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				background: rgba(0,0,0,0.1);
			}
		}

		.disabled {
			opacity: 0.35 !important;
			pointer-events: none !important;
		}

		.approver {
			padding: 6px 10px;
			background: rgba(0,0,0,0.05);
			border-radius: 4px;
		}

		.declined {
			color: red;
		}

		.accepted {
			color: #79c579;
		}
	}
</style>
